import state from '@/onsite/store/state';
import axios from 'axios';
import { setLastQueryStrings } from '@/shared/utility/last-query-strings'

const baseUrl = state.translations.searchScriptUrl;

const actions = {

  setQueryString(store: any, queryString: string) {
    store.commit("SET_QUERY_STRING", queryString)
  },
  setInitialTab(store: any, initialTab: string) {
    store.commit("SET_INITIAL_TAB", initialTab)
  },
  setSelectedTab(store: any, selectedTab: string) {
    store.commit("SET_SELECTED_TAB", selectedTab)
  },
  setAllTabSelected(store:any, status: boolean) {
    store.commit("SET_ALL_TAB_SELECTED", status)
  },
  async initialize(store: any) {
    let url = baseUrl + "?&q=" + state.queryString
    
    await axios.get(url)
      .then(response => {
        store.commit({
          type: "SET_PRODUCTS", 
          config: response.data.config,
          products: response.data.products
        }) 
        store.commit({
          type: "SET_GROUPS", 
          config: response.data.config.groups, 
          results: response.data.groups 
        })
        store.commit("SET_TABS")
        store.commit("SET_TOTAL_RESULTS")

        if (store.state.totalResults > 0) {
          store.commit("SET_LAST_QUERY_STRINGS")
          setLastQueryStrings(store.state.lastQueryStrings);
        }

      }
    )    
  }, 
  async getProducts(store: any) {
    let url = baseUrl + "?group=product&q=" + state.queryString + "&s=" + state.productGroup.results.length
    await axios.get(url, {withCredentials: true})
      .then(response => {
        store.commit({
          type: "ADD_PRODUCTS",
          config: response.data.config,
          products: response.data.products
        })    
      }
    ) 
  },
  async getGroupContent(store: any, id: string) {
    let group = state.groups.find(group => group.id === id)
    if (group) {
      group.detailView = true
      let url = baseUrl + "?group=" + group.id + "&q=" + state.queryString + "&s20=" + ((group.web20ResultsLoaded < group.web20TotalResults) ? group.web20ResultsLoaded.toString() : "-1")
      await axios.get(url, {withCredentials: true})
        .then(response => {
          store.commit("ADD_GROUP_RESULTS", response.data)  
        }
      )    
    }
  }

};

export default actions;
